module.exports = __webpack_public_path__ + "static/phone-4cf3f0afff218eeae6be6476dcdd26a1.jpg";